import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { supabase } from '@/integrations/supabase/supabase';

const AccountLoadError = ({ error }) => {
  const [signingOut, setSigningOut] = useState(false);
  const [signOutError, setSignOutError] = useState(null);

  const signOut = async () => {
    setSigningOut(true);
    setSignOutError(null);
    try {
      const { error: authError } = await supabase.auth.signOut();
      if (authError) throw authError;
      window.location.reload();
    } catch {
      setSignOutError('Sign out failed. Please try again.');
      setSigningOut(false);
    }
  };

  return (
    <main className="min-h-screen bg-gray-50 flex items-center justify-center p-6">
      <section aria-labelledby="account-error-title" className="w-full max-w-md rounded-lg border bg-white p-6 shadow-sm space-y-4">
        <h1 id="account-error-title" className="text-xl font-semibold text-gray-900">Unable to load your account</h1>
        <p role="alert" className="text-sm text-red-700 break-words">Error: {error.message}</p>
        <p className="text-sm text-gray-600">Try again, or sign out to use another account.</p>
        {signOutError && <p role="alert" className="text-sm text-red-700">{signOutError}</p>}
        <div className="flex flex-wrap gap-3">
          <Button disabled={signingOut} onClick={() => window.location.reload()}>Retry</Button>
          <Button variant="outline" disabled={signingOut} onClick={signOut}>
            {signingOut ? 'Signing out...' : 'Sign out'}
          </Button>
        </div>
      </section>
    </main>
  );
};

export default AccountLoadError;
